import { ApprovalParser, CrewListParser, RecordFileParser, VesselParticularsParser, } from "../gateway";
import BookKeyBundleParser from "../gateway/parser/BookKeyBundleParser";
import EquipmentItemParser from "../gateway/parser/EquipmentItemParser";
import VoyageParser from "../gateway/parser/VoyageParser";
import { signEcdsa } from "../signing";
function isApproval(data) {
    return data.approver !== undefined;
}
function isCrew(data) {
    return data.crewMembers !== undefined;
}
function isVesselParticulars(data) {
    return data.version !== undefined;
}
function isVoyage(data) {
    return data.voyageNumber !== undefined;
}
function isRecordFile(data) {
    return data.filename !== undefined;
}
function isEquipmentItem(data) {
    return data.itemData !== undefined;
}
function isBookKeyBundle(data) {
    return data.book !== undefined;
}
function localGetDataToSign(app, data, user, clientDeviceId) {
    let dataToSign;
    if (isApproval(data)) {
        dataToSign = ApprovalParser.toGateway(data, app);
    }
    else if (isVesselParticulars(data)) {
        dataToSign = VesselParticularsParser.toGateway(data, app);
    }
    else if (isCrew(data)) {
        dataToSign = CrewListParser.toGateway(data, app);
    }
    else if (isVoyage(data)) {
        dataToSign = VoyageParser.toGateway(data, app);
    }
    else if (isRecordFile(data)) {
        dataToSign = RecordFileParser.toGateway(data, app);
    }
    else if (isEquipmentItem(data)) {
        dataToSign = EquipmentItemParser.toGateway(data, app);
    }
    else if (isBookKeyBundle(data)) {
        dataToSign = BookKeyBundleParser.toGateway(data, app);
    }
    else {
        if (!data.clientDeviceId) {
            data.clientDeviceId = clientDeviceId || undefined;
        }
        dataToSign = app.get('parseProtocol')(data);
    }
    dataToSign.SignInfo = {
        SignatureMethod: 'ES256',
        KeyInfo: {
            KeyName: user.keyId,
        },
    };
    return dataToSign;
}
export function getDataToSign(app, data, user) {
    return localGetDataToSign(app, data, user);
}
export function addSignature(app, data, user, key, clientDeviceId) {
    const dataToSign = localGetDataToSign(app, data, user, clientDeviceId);
    data.signature = signEcdsa(dataToSign, user.keyId, key);
}
//# sourceMappingURL=SigningUtils.js.map